import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { EffectiveAccessService } from './effective-access.service';

/** Effective global permission codes from GET /identity/AccessControl/Me. */
@Injectable({ providedIn: 'root' })
export class OrchestrationAccessService {
  private readonly effective = inject(EffectiveAccessService);

  /** True when the signed-in user holds the global allow orchestration.admin. */
  hasOrchestrationAdmin(): Observable<boolean> {
    return this.effective.has('orchestration.admin');
  }

  /** True when the caller can administer security independently of process operations. */
  hasAccessManage(): Observable<boolean> {
    return this.effective.has('access.manage');
  }
}
